import { RADIUS } from '../../../constants/sizes';
import { colorPalettes } from '../../../context/theme';
import { getColor } from '../../../context/colors';
import { styled } from '@mui/material';

export const StyledPopoverBox = styled('div')`
  background-color: ${({ theme }) =>
    colorPalettes[theme.palette.mode].components.accountSettings.background
      .primary};
  color: ${({ theme }) =>
    colorPalettes[theme.palette.mode].components.accountSettings.text.primary};
  border-radius: ${RADIUS['medium']};
  box-shadow: 0.3rem 0.3rem 2rem ${getColor('white', 0.1)};
  border: 1px solid ${getColor('mulledWine')};
`;
